import { TranslateService } from '@ngx-translate/core';

import { TranslationKeyMap } from '../../coaching-insight.i18n';
import {
    ColumnConfigItem,
    HeaderExtraContent,
} from '../models/coaching.global.model';

export function getFrontlineMetricsColumnsConfig(
    tls: TranslateService,
): ColumnConfigItem[] {
    return [
        new ColumnConfigItem({
            header: tls.instant(TranslationKeyMap._7485_METRIC_FOCUS),
            colstyle: {
                width: '10rem',
                'min-width': '10rem',
                'max-width': '10rem',
            },
            active: true,
            styles: {
                width: '18%',
                'min-width': '10rem',
                'max-width': '10rem',
            },
            class: [],
            headerContentClass: 'header-content-oa',
            cellstyles: {
                'text-align': 'center',
            },
        }),
        new ColumnConfigItem({
            header: tls.instant(TranslationKeyMap._7476_TOTAL_OPPORTUNITIES),
            active: true,
            colstyle: {
                width: '12%',
                'max-width': '12%',
            },
            styles: {
                width: '12%',
                'max-width': '12%',
            },
            class: [],
            headerContentClass: 'headers-content',
            cellstyles: {
                'text-align': 'center',
            },
        }),
        new ColumnConfigItem({
            header: tls.instant(TranslationKeyMap._7487_OPPORTUNITIES),
            active: true,
            colstyle: {
                width: '70%',
                'max-width': '70%',
            },
            styles: {
                width: '70%',
                'max-width': '70%',
            },
            class: [],
            headerContentClass: 'headers-content',
            cellstyles: {
                'text-align': 'center',
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            left: {
                class: 'funded-coaching-legend',
                /* eslint-disable @typescript-eslint/restrict-template-expressions */
                content: `
                    <div class='funded-coaching-legend-coached'>
                        <span class="legend-square green"></span>
                        <span>${tls.instant(
                            TranslationKeyMap._7488_COACHED,
                        )}</span>
                    </div>
                    <div class='funded-coaching-legend-uncoached'>
                        <span class="legend-square gray"></span>
                        <span>${tls.instant(
                            TranslationKeyMap._7489_UNCOACHED,
                        )}</span>
                    </div>
                `,
            } as HeaderExtraContent,
        }),
    ];
}
